import React, { Component } from 'react';
import styled from 'styled-components';
import iconMixin from 'styles/utils/iconMixin';

const marginCalc = ({ screen }) => {
  let pos = '174px';
  if (screen === 'reset') pos = '246px';
  return `
    margin-top: ${pos}
  `;
};

const AuthErrorDiv = styled.div`
  position: fixed;
  top: 50%;
  right: 0;
  ${marginCalc};
  width: 380px;
  z-index: 1000001;
  background-color: #fff;
`;

const Container = styled.div`
  color: ${(props) => props.theme.colors.notificationError};
`;

const MessageContainer = styled.div`
  order: 1;
  display: flex;
  align-items: center;
`;

const Icon = styled.div`
  ${iconMixin('2rem')};
  padding-left: 33px;
  padding-right: 6px;
  color: ${(props) => props.theme.colors.notificationError};
`;

const Message = styled.div`
  color: ${(props) => props.theme.colors.notificationText};
  font-size: 15px;
`;

export default class AuthError extends Component {
  constructor(props) {
    super(props);
    this.createListData = this.createListData.bind(this);
  }

  createListData(errors) {
    const listArray = [];
    for (const listItem of errors) {
      listArray.push(<li>{listItem}</li>);
    }
    return listArray;
  }

  render() {
    let message;
    if (this.props.errors) {
      const liTags = this.createListData(this.props.errors);
      message = (
        <div>
          <ul>{liTags}</ul>
        </div>
      );
    }

    const messageIcon = this.props.icon;
    return (
      <AuthErrorDiv screen={this.props.screen}>
        <Container>
          <MessageContainer>
            <Icon>{messageIcon}</Icon>
            <Message>{message ? message : this.props.message}</Message>
          </MessageContainer>
        </Container>
      </AuthErrorDiv>
    );
  }
}
